import { useState } from 'react';

import { Button, Icon } from 'shared/components/ui';

import { ShareProjectModal } from '../ShareProjectModal';

interface Props {
	projectId: number;
}

export const ShareProject = ({ projectId }: Props) => {
	const [openModal, setOpenModal] = useState(false);

	const handleOpenModal = () => {
		setOpenModal(true);
	};

	const handleCloseModal = () => {
		setOpenModal(false);
	};

	return (
		<>
			<Button onClick={handleOpenModal} type="default" prefix={<Icon icon="user-plus" />}>
				Share project
			</Button>
			{openModal && <ShareProjectModal onClose={handleCloseModal} projectId={projectId} />}
		</>
	);
};
